/**
 * @generated SignedSource<<2c86fa75f79aea17f41a87ef07f602e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgFeatures = "ANALYTICS" | "FILES" | "MAP" | "PRODUCTS" | "ROUTINES" | "SIGNALS" | "SPACES" | "TODOS";
export type TodoResponseType = "IMAGES" | "NUMBER" | "TEXT";
export type WorkspaceTodoStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "SCHEDULED";
export type WorkspaceTodoDetailScreenQuery$variables = {
  todoId: string;
  workspaceId: string;
};
export type WorkspaceTodoDetailScreenQuery$data = {
  readonly organisation: {
    readonly features: ReadonlyArray<OrgFeatures>;
  } | null;
  readonly todoWorkspace: {
    readonly archivedAtDate: {
      readonly __typename: "UnzonedDate";
    } | null;
    readonly id: string;
    readonly isWorkspaceOwner: boolean;
    readonly responseType: TodoResponseType | null;
    readonly scheduledArchiveAt: {
      readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
    } | null;
    readonly status: WorkspaceTodoStatus;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoDetailList_todoWorkspace" | "WorkspaceTodoDetailScreenHeader_todoWorkspace">;
  } | null;
};
export type WorkspaceTodoDetailScreenQuery = {
  response: WorkspaceTodoDetailScreenQuery$data;
  variables: WorkspaceTodoDetailScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "features",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "todoId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
],
v6 = {
  "alias": null,
  "args": (v5/*: any*/),
  "kind": "ScalarField",
  "name": "isWorkspaceOwner",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "UnzonedDate",
  "kind": "LinkedField",
  "name": "archivedAtDate",
  "plural": false,
  "selections": [
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responseType",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v12 = [
  (v11/*: any*/)
],
v13 = [
  {
    "kind": "InlineFragment",
    "selections": (v12/*: any*/),
    "type": "Date",
    "abstractKey": "__isDate"
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = [
  (v11/*: any*/),
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isDate"
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbhash",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlExpiresAt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v21 = [
  (v4/*: any*/),
  (v16/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageSize",
    "kind": "LinkedField",
    "name": "sizes",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/)
    ],
    "storageKey": null
  }
],
v22 = [
  (v4/*: any*/),
  (v14/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoDetailScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoWorkspace",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "scheduledArchiveAt",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FormattedDate"
              }
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceTodoDetailList_todoWorkspace"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceTodoDetailScreenHeader_todoWorkspace"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceTodoDetailScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoWorkspace",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "scheduledArchiveAt",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": (v5/*: any*/),
            "kind": "ScalarField",
            "name": "todoCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "kind": "ScalarField",
            "name": "todosCompletedCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todos",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "store",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timezone",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commentCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreZonedDate",
                "kind": "LinkedField",
                "name": "resolvedAtDate",
                "plural": false,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "response",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isTodoResponse"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": (v21/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "TodoResponseImage",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "type": "TodoResponseNumber",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      }
                    ],
                    "type": "TodoResponseText",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Todo",
                "kind": "LinkedField",
                "name": "subTodos",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "publishedAtDate",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "publishedBy",
            "plural": false,
            "selections": (v22/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formattedBody",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedBySessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "descriptionImages",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageSize",
                "kind": "LinkedField",
                "name": "sizes",
                "plural": true,
                "selections": [
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v4/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "descriptionFiles",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOrg",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FilePage",
                "kind": "LinkedField",
                "name": "pages",
                "plural": true,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "thumbnail",
                "plural": false,
                "selections": (v21/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkspaceProduct",
            "kind": "LinkedField",
            "name": "linkedProducts",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "partNumber",
                "storageKey": null
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "updatedBy",
            "plural": false,
            "selections": (v22/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "expireAtDate",
            "plural": false,
            "selections": (v12/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "updatedAtDate",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priority",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sendNotificationAtPublish",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a6c816ca712b1eae1d3ebb6f8a1e417b",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoDetailScreenQuery",
    "operationKind": "query",
    "text": "query WorkspaceTodoDetailScreenQuery(\n  $workspaceId: ID!\n  $todoId: ID!\n) {\n  organisation {\n    features\n    id\n  }\n  todoWorkspace(id: $todoId) {\n    id\n    isWorkspaceOwner(workspaceId: $workspaceId)\n    archivedAtDate {\n      __typename\n    }\n    scheduledArchiveAt {\n      ...FormattedDate\n    }\n    status\n    responseType\n    ...WorkspaceTodoDetailList_todoWorkspace\n    ...WorkspaceTodoDetailScreenHeader_todoWorkspace\n  }\n}\n\nfragment AHImageStackComponent_Images on Image {\n  id\n  ...Image_image\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment LinkedContentInput_files on File {\n  ...LinkedContent_files\n}\n\nfragment LinkedContentInput_images on Image {\n  ...LinkedContent_images\n}\n\nfragment LinkedContent_files on File {\n  id\n  name\n  type\n  url\n  ...LinkedFileItem_file\n}\n\nfragment LinkedContent_images on Image {\n  id\n  sizes {\n    height\n    width\n    id\n  }\n  ...Image_image\n  ...LinkedImageItem_image\n}\n\nfragment LinkedFileItem_file on File {\n  id\n  name\n  ...FileIcon_File\n  pages {\n    id\n  }\n  thumbnail {\n    id\n    ...Image_image\n  }\n}\n\nfragment LinkedImageItem_image on Image {\n  id\n  ...Image_image\n}\n\nfragment LinkedWorkspaceProductItem_WorkspaceProduct on WorkspaceProduct {\n  id\n  imageUrl\n  partNumber\n  name\n}\n\nfragment WorkspaceTodoDetailList_todoWorkspace on TodoWorkspace {\n  ...WorkspaceTodoListHeader_todoWorkspace\n  archivedAtDate {\n    __typename\n  }\n  responseType\n  todos(workspaceId: $workspaceId) {\n    id\n    store {\n      name\n      id\n    }\n    commentCount\n    resolvedAtDate {\n      isoString\n    }\n    response {\n      __typename\n      ... on TodoResponseImage {\n        images {\n          id\n        }\n      }\n    }\n    ...WorkspaceTodoStoresGalleryItem_todo\n    ...WorkspaceTodoStoresListItem_todo\n  }\n}\n\nfragment WorkspaceTodoDetailScreenHeader_todoWorkspace on TodoWorkspace {\n  ...WorkspaceTodoEditMainContent_Todo\n  ...WorkspaceTodoEditMainProducts_TodoWorkspace\n  ...WorkspaceTodoEditMainExpireSelector_Todo\n  ...WorkspaceTodoEditMainPrioritySelector_Todo\n  ...WorkspaceTodoEditMainResponseType_TodoWorkspace\n  ...WorkspaceTodoEditMainPushNotification_todoWorkspace\n}\n\nfragment WorkspaceTodoEditMainContent_Todo on TodoWorkspace {\n  id\n  title\n  body\n  publishedAtDate {\n    ...FormattedDate\n  }\n  publishedBy {\n    id\n    name\n  }\n  formattedBody\n  updatedBySessionId\n  ...WorkspaceTodoLinkedContent_todo\n}\n\nfragment WorkspaceTodoEditMainExpireSelector_Todo on TodoWorkspace {\n  id\n  updatedBy {\n    id\n    name\n  }\n  expireAtDate {\n    isoString\n  }\n  updatedAtDate {\n    ...FormattedDate\n    isoString\n  }\n}\n\nfragment WorkspaceTodoEditMainPrioritySelector_Todo on TodoWorkspace {\n  id\n  priority\n  updatedAtDate {\n    ...FormattedDate\n    isoString\n  }\n}\n\nfragment WorkspaceTodoEditMainProducts_TodoWorkspace on TodoWorkspace {\n  id\n  linkedProducts {\n    id\n    ...LinkedWorkspaceProductItem_WorkspaceProduct\n  }\n}\n\nfragment WorkspaceTodoEditMainPushNotification_todoWorkspace on TodoWorkspace {\n  id\n  sendNotificationAtPublish\n  updatedAtDate {\n    ...FormattedDate\n    isoString\n  }\n  updatedBy {\n    name\n    id\n  }\n}\n\nfragment WorkspaceTodoEditMainResponseType_TodoWorkspace on TodoWorkspace {\n  id\n  responseType\n  responseDescription\n  updatedAtDate {\n    ...FormattedDate\n    isoString\n  }\n  updatedBy {\n    name\n    id\n  }\n}\n\nfragment WorkspaceTodoLinkedContent_todo on TodoWorkspace {\n  id\n  descriptionImages {\n    id\n    ...LinkedContentInput_images\n  }\n  descriptionFiles {\n    id\n    ...LinkedContentInput_files\n  }\n}\n\nfragment WorkspaceTodoListHeader_todoWorkspace on TodoWorkspace {\n  id\n  todoCount(workspaceId: $workspaceId)\n  todosCompletedCount(workspaceId: $workspaceId)\n  responseType\n}\n\nfragment WorkspaceTodoStoresGalleryItem_todo on Todo {\n  store {\n    id\n    name\n    timezone\n  }\n  status\n  id\n  subTodos {\n    status\n    id\n  }\n  response {\n    __typename\n    ... on TodoResponseImage {\n      images {\n        id\n        ...Image_image\n      }\n    }\n  }\n  resolvedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment WorkspaceTodoStoresListItemResponseImage_todoImageResponse on TodoResponseImage {\n  images {\n    id\n    sizes {\n      height\n      width\n      id\n    }\n    ...Image_image\n    ...AHImageStackComponent_Images\n  }\n  __typename\n}\n\nfragment WorkspaceTodoStoresListItemResponse_todoResponse on TodoResponse {\n  __isTodoResponse: __typename\n  ... on TodoResponseNumber {\n    value\n    __typename\n  }\n  ... on TodoResponseImage {\n    ...WorkspaceTodoStoresListItemResponseImage_todoImageResponse\n    __typename\n  }\n  ... on TodoResponseText {\n    text\n    __typename\n  }\n}\n\nfragment WorkspaceTodoStoresListItem_todo on Todo {\n  store {\n    id\n    name\n    timezone\n  }\n  status\n  id\n  subTodos {\n    status\n    id\n  }\n  response {\n    __typename\n    ...WorkspaceTodoStoresListItemResponse_todoResponse\n  }\n  resolvedAtDate {\n    ...FormattedDate\n  }\n  commentCount\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "8cefb56008a5bbe5ed3e27ee5eae9c22";

export default node;
